module.exports = __webpack_public_path__ + "static/media/editor.eea321d6.svg";